import { combineReducers } from 'redux'
import {
  reducer as globalReducer,
  reducerKey as globalReducerKey,
} from './global-reducer'

import {
  reducer as profileReducer,
  reducerKey as profileReducerKey,
} from './profile/reducer'

const reducerKey = 'artistPortal'

// Combine reducers
const reducer = combineReducers({
  [globalReducerKey]: globalReducer,
  [profileReducerKey]: profileReducer,
})

export { reducer, reducerKey }
